/*************************************************
 * ByzFunder
 * @exports
 * App.tsx
 * Created by vinoth kumar on 08/05/2024
 * Copyright © 2024 ByzFunder. All rights reserved.
 *************************************************/
import React, { useEffect } from "react";
import Routerconfig from "./routes";
import CookieConsent from "react-cookie-consent";
import { initSmartlook } from "./lib/smartlook";
import { initLogRocket } from "./lib/logrocket";
import { useAuth } from "./hooks/UseAuth";

function App() {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      initSmartlook(user);
      initLogRocket(user);
    }
  }, [user]);

  return (
    <React.Fragment>
      <CookieConsent
        location="bottom"
        buttonText="I agree"
        cookieName="myAppCookieConsent"
        style={{
          background: "var(--color-primary)",
          color: "#fff",
          fontSize: "14px",
        }}
        buttonStyle={{
          background: "#fff",
          color: "var(--color-primary)",
          borderRadius: "20px",
          fontWeight: "600",
          padding: "6px 16px",
          border: "none",
        }}
        expires={150}
      >
        This website uses cookies to enhance the user experience.
      </CookieConsent>
      <Routerconfig />
    </React.Fragment>
  );
}

export default App;
